import React from 'react';
import AppLogo from '@/components/ui/AppLogo';
import { CheckCircle2, BookOpen, Timer, BarChart2 } from 'lucide-react';

const FEATURES = [
  { icon: BookOpen, text: 'Organize courses and deadlines in one place', key: 'feat-courses' },
  { icon: CheckCircle2, text: 'Track tasks with priority, type, and progress', key: 'feat-tasks' },
  { icon: Timer, text: 'Pomodoro timer with automatic session logging', key: 'feat-timer' },
  { icon: BarChart2, text: 'Analytics to understand your study patterns', key: 'feat-analytics' },
];

export default function AuthBrandPanel() {
  return (
    <div className="hidden lg:flex flex-col justify-between w-[480px] xl:w-[540px] flex-shrink-0 bg-primary p-12 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-white/5 -translate-y-32 translate-x-32" />
      <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-white/5 translate-y-40 -translate-x-20" />
      {/* Logo */}
      <div className="relative z-10 flex items-center gap-3">
        <AppLogo size={40} />
        <span className="text-2xl font-bold text-white tracking-tight">StudyMate</span>
      </div>
      {/* Hero copy */}
      <div className="relative z-10 space-y-8">
        <div>
          <h1 className="text-4xl font-bold text-white leading-tight mb-4">
            Your personal<br />academic workspace.
          </h1>
          <p className="text-white/70 text-lg leading-relaxed">
            Stay on top of deadlines, track study sessions, and finish every semester with confidence.
          </p>
        </div>

        {/* Features list */}
        <ul className="space-y-4">
          {FEATURES?.map((f) => (
            <li key={f?.key} className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-lg bg-white/15 flex items-center justify-center flex-shrink-0 mt-0.5">
                <f.icon size={16} className="text-white" />
              </div>
              <span className="text-white/85 text-sm leading-relaxed">{f?.text}</span>
            </li>
          ))}
        </ul>
      </div>
      {/* Footer quote */}
      <div className="relative z-10">
        <p className="text-white/50 text-sm italic">
          "The secret of getting ahead is getting started."
        </p>
        <p className="text-white/40 text-xs mt-1">— Mark Twain</p>
      </div>
    </div>
  );
}